import React, { useContext, useEffect, useState } from 'react';
import { GlobeIcon } from "@phosphor-icons/react";
import { AnimatePresence, motion } from "framer-motion";
import { useOutsideClick } from "@/core/hooks/useOutSideClick";
import ChooseRegionContext from "@/providers/choose-region/context";

import i18next from '@/i18n';
import { initialRegion, RegionActions } from '@/providers/choose-region/reducer';
import { useTranslation } from 'react-i18next';

function ChooseLanguageRegion() {
  const { t } = useTranslation();
  const { regionSelected, listRegion, dispatch } = useContext(ChooseRegionContext)
  const [open, setOpen] = useState<boolean>(false);
  const refChooseLanguageRegion = useOutsideClick(() => {
    setOpen(false);
  });

  const openDropdown = (e: any) => {
    e.preventDefault();
    setOpen((prev) => !prev);
  };

  const handleChooseRegion = async (value: string) => {
    try {
      dispatch({
        type: RegionActions.UPDATE,
        payload: value
      });
      setOpen(false); // explicitly close the dropdown
      await i18next.changeLanguage(value);
      // Optionally save the language preference to localStorage
      localStorage.setItem('i18nextLng', value);
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  }

  useEffect(() => {
    dispatch({
      type: RegionActions.UPDATE,
      payload: localStorage.getItem('i18nextLng') || initialRegion
    });
  }, [])

  return (
    <div className="choose-language-region" ref={refChooseLanguageRegion} title={t('common.language')}>
      <a className={`choose-language-region__button ${open ? 'active' : ''}`} onClick={openDropdown}>
        <GlobeIcon size={22} />
      </a>
      <AnimatePresence>
        {open ? (
          <motion.div
            initial={{ opacity: 0, translateY: -20 }}
            animate={{ opacity: 1, translateY: 0 }}
            exit={{ opacity: 0, translateY: 0 }}
            transition={{
              type: "spring",
              stiffness: 400,
              damping: 30,
              mass: 1,
              delay: 0,
            }}
            className="choose-language-region-modal"
          >
            <h3>{t("common.switch_lang")}</h3>
            <div className="choose-language-list">
              {listRegion.map((item, index) =>
                <div
                  key={index}
                  className={`choose-language-list-item ${regionSelected === item.value ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
                  onClick={() => handleChooseRegion(item.value)}
                >
                  {item.name}
                </div>
              )}
            </div>
          </motion.div>
        ) : (
          <></>
        )}
      </AnimatePresence>
    </div>

  );
}

export default ChooseLanguageRegion;
